import type { FaireProductEntity } from "../../entity_types/product";

export const p_mg8vnazqqd: FaireProductEntity = {
  token: "p_mg8vnazqqd",
  type: "product",
  name: "Crushed Tangerine Vinegar (8oz)",
  brandToken: "b_8v4yrvb98p",
  brandName: "Kosterina",
  imageUrl:
    "https://cdn.faire.com/fastly/6863f15dbdb45404cc2db24edbcd5b77976995372c848d63b09721ce77d7dfa7.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c58f35b78dc42faaf2be5af7b0c1e16b9968f8917ac6b3efadb8e1e88bd50d75.jpeg",
    "https://cdn.faire.com/fastly/a12c33d674e024c635c91a335a4d0d1ff02563d6794d2c0a68a6c0a36a4ff465.jpeg",
  ],
  priceDollars: 11.78,
  description:
    "Our Crushed Fruit Vinegars are the perfect combination of tangy and sweet, with no added sugar. Made from only 3 ingredients, they are pure, simple, and delicious. \n \n Our Crushed Tangerine flavor is a best-seller. It is more tart and citrus forward than our other flavors yet with a similar sweet burst of fresh fruit flavor\n \n Ingredients:\n - White Wine Vinegar\n - White Cooked Grape Must\n - Fresh Crushed Tangerine Puree \n \n Makes for great marinade or salad dressing or use it as a shrub in cocktails and mocktails (simply mix with selzer!). \n \n No refrigeration needed.",
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:01.117Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
